import { useState } from 'react';
import ZyfoxWhiteLogo from '../Images/ZyfoxWhiteLogo.png';

const Navbar = () => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToImageGen = () => {
    const element = document.getElementById('image-gen-section');
    if (element) {
      const navbarHeight = 100;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - navbarHeight,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 100;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - navbarHeight,
        behavior: 'smooth'
      });
    }
    setIsServicesOpen(false);
    setIsMobileMenuOpen(false);
  };

  const services = [
    { name: 'AI Image Generation', id: 'image-gen-section' },
    { name: 'AI Video Generation', id: 'video-gen-section' },
    { name: 'AI Visual Effects', id: 'vfx-section' },
    { name: 'AI 3D Model Generation', id: '3d-section' },
  ];

  return (
    <>
      {/* Fixed Zyfox logo in top left corner - visible on desktop only */}
      <a 
        href="https://zyfoxwebsite.web.app/" 
        className="nav-logo-fixed fixed left-4 sm:left-6 top-4 sm:top-6 z-[60] animate-fade-in-down cursor-pointer"
        onClick={(e) => {
          e.preventDefault();
          window.location.href = 'https://zyfoxwebsite.web.app/';
        }}
      >
        <img src={ZyfoxWhiteLogo} alt="Zyfox" className="h-10 sm:h-14 hover:opacity-80 transition-opacity" loading="lazy" />
      </a>

      <nav className="fixed left-0 right-0 top-3 sm:top-6 z-50 flex justify-center px-2 sm:px-4 animate-fade-in-down">
        <div className="nav-inner flex h-14 sm:h-16 w-full max-w-5xl items-center justify-between rounded-full px-3 sm:px-6 bg-black/40 border border-white/10">
          {/* Logo section - Desktop: AI Edits icon + text, Mobile: Zyfox logo */}
          <div className="nav-logo flex items-center gap-2 sm:gap-3">
            {/* Desktop - AI Edits */}
            <div className="hidden sm:flex items-center gap-2 sm:gap-3">
              <div className="flex h-7 w-7 sm:h-8 sm:w-8 items-center justify-center rounded-full bg-primary/20 text-primary">
                <span className="material-symbols-outlined text-lg sm:text-xl">smart_toy</span>
              </div>
              <span className="text-base sm:text-lg font-bold tracking-tight text-white">AI Edits</span>
            </div>
            {/* Mobile - Zyfox logo */}
            <a 
              href="https://zyfoxwebsite.web.app/"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = 'https://zyfoxwebsite.web.app/';
              }}
            >
              <img src={ZyfoxWhiteLogo} alt="Zyfox" className="h-10 sm:hidden hover:opacity-80 transition-opacity" loading="lazy" />
            </a>
          </div>

          {/* Desktop Navigation - Services Dropdown */}
          <div 
            className="nav-links relative"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={() => setIsServicesOpen(false)}
          >
            <button className="flex items-center gap-1 text-sm text-white/70 hover:text-white transition-colors px-3 py-2">
              Services
              <span className={`material-symbols-outlined text-sm transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}>
                expand_more
              </span>
            </button>
            
            {isServicesOpen && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
                <div className="w-56 glass-panel rounded-xl py-2 shadow-xl">
                  {services.map((service) => (
                    <button
                      key={service.id}
                      onClick={() => scrollToSection(service.id)}
                      className="w-full text-left px-4 py-2.5 text-sm text-white/70 hover:text-primary hover:bg-white/5 transition-colors"
                    >
                      {service.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Desktop - Center text */}
          <span className="nav-center-text text-xs sm:text-sm text-white/60 uppercase tracking-wider">Automate your work...</span>
          
          {/* Desktop CTA Button */}
          <div className="nav-cta-btn flex items-center">
            <button 
              onClick={scrollToImageGen}
              className="btn-glow flex h-8 sm:h-10 items-center justify-center rounded-full bg-primary px-3 sm:px-5 text-xs sm:text-sm font-bold text-background-dark"
            >
              Generate Now
            </button>
          </div>

          {/* Mobile Hamburger Button */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-menu fixed top-20 left-2 right-2 z-40 glass-panel rounded-2xl p-4 animate-fade-in-down">
          <div className="flex flex-col gap-2">
            <p className="text-xs text-white/40 uppercase tracking-wider px-3 py-2">Services</p>
            {services.map((service) => (
              <button
                key={service.id}
                onClick={() => scrollToSection(service.id)}
                className="w-full text-left px-3 py-3 text-sm text-white/70 hover:text-primary hover:bg-white/5 rounded-lg transition-colors"
              >
                {service.name}
              </button>
            ))}
            <div className="h-px bg-white/10 my-2"></div>
            <button 
              onClick={scrollToImageGen}
              className="btn-glow flex h-12 items-center justify-center rounded-full bg-primary px-5 text-sm font-bold text-background-dark"
            >
              Generate Now
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
